import { SettingError } from "./types";

// The API's own rules for the local part of an inbox address, checked here as well so the form says what is wrong
// before Create rather than after the round trip.
const INBOX_ADDRESS_PATTERN = /^[a-z0-9][a-z0-9._-]{0,62}$/;

const RESERVED_INBOX_ADDRESSES = new Set(["postmaster", "abuse", "noreply"]);

export const getInboxAddressError = (address: string): SettingError | null => {
  if (address.includes("@")) {
    return { key: "superadmin:connections.detail.validation.address_at" };
  }

  if (!INBOX_ADDRESS_PATTERN.test(address)) {
    return { key: "superadmin:connections.detail.validation.address_format" };
  }

  if (RESERVED_INBOX_ADDRESSES.has(address)) {
    return {
      key: "superadmin:connections.detail.validation.address_reserved",
      values: { address },
    };
  }

  return null;
};
